import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const ImeiValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const regExp = /^[0-9]{15,17}$/;
  return control?.value && !regExp?.test(control?.value) ? { imei: true } : null;
};
